import React, { useEffect } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import { connect } from "react-redux";
import UserGuide from "./pages/UserGuide";
import TrainingProviders from "./pages/TrainingProviders";
import Settings from "./pages/Settings";
import Trainings from "./pages/Trainings";

import {
  getProgramCategories,
  getTraineeSubCategories,
  getOrganizationTypes,
  getPrograms,
  getTraingProviderAttachmentTypes,
  getCountries,
} from "../../../store/cpd/actions";
import { getSchoolSubLevels } from "../../../store/posts/actions";

import Dashboard from "./pages/Dashboard";
import Trainers from "./pages/Trainers";
import MembershipRequests from "./pages/MembershipRequests";
import TrainingAttendanceReport from "./pages/TrainingAttendanceReport";

const Layout = (props) => {
  useEffect(() => {
    document.title = "TMIS | Trainings";
  }, []);

  const {
    user,
    programs,
    getProgramCategories,
    getSchoolSubLevels,
    getTraineeSubCategories,
    getOrganizationTypes,
    getPrograms,
    getTraingProviderAttachmentTypes,
    getCountries,
  } = props;
  const history = useHistory();

  useEffect(() => {
    getProgramCategories();
    getSchoolSubLevels();
    getOrganizationTypes();
    getPrograms();
    getTraingProviderAttachmentTypes();
    getCountries();

    // getTraineeSubCategories();
  }, []);

  return (
    <React.Fragment>
      <Switch>
        <Route path="/in/cpd/dashboard" component={Dashboard} />
        <Route
          path="/in/cpd/membership-requests"
          component={MembershipRequests}
        />
        <Route path="/in/cpd/providers" component={TrainingProviders} />
        <Route path="/in/cpd/trainers" component={Trainers} />
        <Route path="/in/cpd/trainings" component={Trainings} />
        <Route
          path="/in/cpd/report"
          component={TrainingAttendanceReport}
        />
        <Route path="/in/cpd/settings" component={Settings} />
        <Route path="/in/cpd/user-guide" component={UserGuide} />

        <Route
          path="/in/cpd"
          component={() => <Redirect to="/in/cpd/dashboard" />}
        />
      </Switch>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user, programs }) => {
  return {
    user,
    programs,
  };
};
export default connect(mapStateToProps, {
  getProgramCategories,
  getSchoolSubLevels,
  getTraineeSubCategories,
  getOrganizationTypes,
  getPrograms,
  getTraingProviderAttachmentTypes,
  getCountries,
})(Layout);
